module.exports = "/images/job-transfer.png?131acf6e5a1236fe96c444fc574694a7";